import React, { memo } from "react"
import { makeStyles } from "@material-ui/core"
import moment from "moment-timezone"
import { getTimeZoneAbbreviation, hasTimeOffsetFromUser, useDateUtils } from "../../utils"
import { useAuth } from "../../services"

const useStyles = makeStyles((theme) => ({
  overdue: {
    color: theme.palette.error.main
  }
}))

const FormatTime = ({
  value,
  showOverdue = false,
  overdueSuffix = "",
  timeZone,
  showLocalTooltip = false,
  showTimeZoneIfHasOffset = false,
  localTooltipSameFormat = false
}) => {
  const {
    location: { timeZone: locationTimeZone }
  } = useAuth()
  const { formatTime } = useDateUtils()
  const classes = useStyles()
  const safeTimeZone = timeZone || locationTimeZone
  const isOverdue = showOverdue && value && moment(value).tz(safeTimeZone).isSameOrBefore(moment())

  const getLocalTooltipFormat = () => (localTooltipSameFormat ? "h:mm A" : undefined)

  const title = showLocalTooltip
    ? moment(value).local().format(getLocalTooltipFormat())
    : moment(value).tz(safeTimeZone).format(getLocalTooltipFormat())

  try {
    return (
      <span className={isOverdue ? classes.overdue : null} title={title}>
        {value && formatTime(value, safeTimeZone)}
        {showTimeZoneIfHasOffset && hasTimeOffsetFromUser(safeTimeZone) && (
          <span title={moment(value).local().format()}> {getTimeZoneAbbreviation(value, safeTimeZone)}</span>
        )}
        {isOverdue && overdueSuffix && <> {overdueSuffix}</>}
      </span>
    )
  } catch (ex) {
    return <>Data invalid.</>
  }
}

const FormatTimeMemo = memo(FormatTime)

export { FormatTimeMemo as FormatTime }
